var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0026 24.3333H5.34327C3.2459 24.3333 2.19721 24.3333 1.97657 24.1705C1.72868 23.9875 1.66811 23.8795 1.64127 23.5726C1.61738 23.2994 2.26012 22.2477 3.54562 20.1443C4.87286 17.9726 5.99986 14.8104 5.99986 10.3333C5.99986 7.85798 7.05343 5.48401 8.92879 3.73367C10.8042 1.98333 13.3477 1 15.9999 1C18.652 1 21.1956 1.98333 23.0709 3.73367C24.9463 5.48401 25.9999 7.85798 25.9999 10.3333C25.9999 14.8104 27.1268 17.9726 28.4541 20.1443C29.7396 22.2477 30.3823 23.2994 30.3584 23.5726C30.3316 23.8795 30.271 23.9875 30.0231 24.1705C29.8025 24.3333 28.7538 24.3333 26.6564 24.3333H20.9999M11.0026 24.3333L10.9999 26C10.9999 28.7614 13.2384 31 15.9999 31C18.7613 31 20.9999 28.7614 20.9999 26V24.3333M11.0026 24.3333H20.9999",
    stroke: "#394B42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/notifications_icon.91afd242c67610352da8b9bd2e4ee239.svg";
export { ForwardRef as ReactComponent };